/**
 * Catalog Add to cart: yellow clears from the top down into the in-cart bar.
 * At one copy, trash removes the line. At two or more, that control is a minus and drops one copy. Plus adds one more when another copy is in stock.
 */
(function () {
  if (window.__riCardAtc) return;
  window.__riCardAtc = true;
  var items = [];
  var paintTimer = 0;

  /* What the shopper sees holds until the cart has caught up (owner, 2026-10-23: an add swiped in, swiped back, then
     in again; plus did the same). A cart read that started before the latest change, or lands while a change is
     still on its way, is older than the screen, so it is dropped. Whoever finishes last reads the cart once more. */
  var epoch = 0;
  var inflight = 0;
  var formChanges = [];

  function beginChange() {
    epoch += 1;
    inflight += 1;
    return epoch;
  }

  function endChange() {
    inflight = Math.max(0, inflight - 1);
  }

  function onceEnd() {
    var ended = false;
    return function () {
      if (ended) return;
      ended = true;
      endChange();
    };
  }

  function settled(start) {
    return inflight === 0 && start === epoch;
  }

  /* A change's own answer paints only if nothing newer started; otherwise the last one to finish reads the cart. */
  function finishWith(start, cart) {
    if (cart && settled(start)) applyCart(cart, true);
    else if (inflight === 0) loadCart(true);
  }

  /* Dawn's product form adds the chooser's versions. Its answer is the cartUpdate (or cartError) it publishes. */
  function beginFormChange() {
    beginChange();
    var token = {};
    token.timer = window.setTimeout(function () {
      endFormChange(token);
    }, 10000);
    formChanges.push(token);
  }

  function endFormChange(token) {
    var i = token ? formChanges.indexOf(token) : 0;
    if (i < 0 || !formChanges.length) return false;
    var done = formChanges.splice(i, 1)[0];
    window.clearTimeout(done.timer);
    endChange();
    if (token && inflight === 0) loadCart(true);
    return true;
  }

  function cartJsUrl() {
    var base = (window.routes && window.routes.cart_url) || '/cart';
    return base + '.js';
  }

  function qtyOf(id) {
    var key = String(id);
    var total = 0;
    items.forEach(function (item) {
      var vid = item.variant_id != null ? item.variant_id : item.id;
      if (String(vid) === key) total += item.quantity || 0;
    });
    return total;
  }

  function lineOf(id) {
    var key = String(id);
    var line = null;
    items.forEach(function (item) {
      var vid = item.variant_id != null ? item.variant_id : item.id;
      if (String(vid) === key) line = item;
    });
    return line;
  }

  function paintButton(btn) {
    if (btn.disabled && !btn.hasAttribute('data-ri-atc-variant')) return;
    var qty = qtyOf(btn.getAttribute('data-ri-atc-variant'));
    var sw = btn.closest('.ri-card-atc__switch');
    if (!sw) return;
    var face = sw.querySelector('.ri-card-atc__qtyface');
    var qtyEl = sw.querySelector('[data-ri-atc-qty]');
    if (qty > 0) {
      /* At the stock limit the + is hidden, which says it; no (only N in stock) words (owner, 2026-10-22). */
      var label = qty + ' in cart';
      if (qtyEl && qtyEl.textContent !== label) qtyEl.textContent = label;
      sw.classList.remove('is-leaving');
      sw.classList.add('is-in-cart');
      btn.setAttribute('aria-hidden', 'true');
      btn.tabIndex = -1;
      if (face) {
        face.removeAttribute('aria-hidden');
        face.removeAttribute('inert');
      }
      paintRemove(sw, qty);
    } else if (sw.classList.contains('is-in-cart')) {
      leaveCart(sw);
    } else {
      if (qtyEl && qtyEl.textContent) qtyEl.textContent = '';
      sw.classList.remove('is-in-cart');
      btn.removeAttribute('aria-hidden');
      if (btn.tabIndex === -1) btn.removeAttribute('tabindex');
      if (face) {
        face.setAttribute('aria-hidden', 'true');
        face.setAttribute('inert', '');
      }
      paintRemove(sw, 0);
    }
  }

  function paintRemove(sw, qty) {
    var btn = sw.querySelector('[data-ri-atc-remove]');
    if (!btn) return;
    if (!btn.getAttribute('data-ri-remove-label')) {
      btn.setAttribute('data-ri-remove-label', btn.getAttribute('aria-label') || 'Remove');
    }
    var many = qty >= 2;
    btn.classList.toggle('is-minus', many);
    btn.setAttribute('aria-label', many ? 'Remove one' : btn.getAttribute('data-ri-remove-label'));
  }

  function paintPlus(btn) {
    var max = parseInt(btn.getAttribute('data-ri-atc-max') || '0', 10);
    var qty = qtyOf(btn.getAttribute('data-ri-atc-plus'));
    var ready = qty > 0 && max > qty;
    btn.classList.toggle('is-ready', ready);
    btn.disabled = !ready;
    if (!btn.getAttribute('data-ri-plus-label')) {
      btn.setAttribute('data-ri-plus-label', btn.getAttribute('aria-label') || 'Add one more');
    }
    btn.setAttribute(
      'aria-label',
      qty > 0 && max > 0 && qty >= max ? 'Only ' + max + ' in stock' : btn.getAttribute('data-ri-plus-label')
    );
    if (ready) {
      btn.removeAttribute('aria-hidden');
      btn.removeAttribute('tabindex');
    } else {
      btn.setAttribute('aria-hidden', 'true');
      btn.tabIndex = -1;
    }
  }

  function qtyStill(sw) {
    var btn = sw.querySelector('[data-ri-atc-variant]');
    if (btn) return qtyOf(btn.getAttribute('data-ri-atc-variant')) > 0;
    if (!sw.hasAttribute('data-ri-choose-switch')) return false;
    var card = sw.closest('.ri-catalog-card') || sw.parentElement;
    var chooser = card && card.querySelector('ri-choose-options');
    if (!chooser) return false;
    var buttons = chooser.querySelectorAll('[data-ri-atc-variant]');
    for (var i = 0; i < buttons.length; i++) {
      if (qtyOf(buttons[i].getAttribute('data-ri-atc-variant')) > 0) return true;
    }
    return false;
  }

  /* Keep the white in-cart row until the yellow wipe has covered it. */
  function leaveCart(sw) {
    if (sw.classList.contains('is-leaving')) return;
    sw.classList.add('is-leaving');
    var form = sw.querySelector(':scope > product-form');
    var face = sw.querySelector(':scope > .ri-pdp-atc__face');
    var chooseBtn = sw.classList.contains('ri-card-atc__switch--choose')
      ? sw.querySelector(':scope > .ri-card-atc__btn')
      : null;
    var target = form || face || chooseBtn || sw;
    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      if (qtyStill(sw)) {
        sw.classList.remove('is-leaving');
        return;
      }
      sw.classList.remove('is-leaving');
      sw.classList.remove('is-in-cart');
      paint();
    };
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      finish();
      return;
    }
    var onEnd = function (evt) {
      if (evt.target !== target || evt.propertyName !== 'clip-path') return;
      target.removeEventListener('transitionend', onEnd);
      finish();
    };
    target.addEventListener('transitionend', onEnd);
    window.setTimeout(finish, 460);
  }

  function paintChoose() {
    document.querySelectorAll('[data-ri-choose-switch]').forEach(function (sw) {
      var card = sw.closest('.ri-catalog-card') || sw.parentElement;
      var chooser = card && card.querySelector('ri-choose-options');
      var withQty = [];
      if (chooser) {
        chooser.querySelectorAll('[data-ri-atc-variant]').forEach(function (btn) {
          var id = btn.getAttribute('data-ri-atc-variant');
          var qty = qtyOf(id);
          if (qty > 0) withQty.push({ id: id, qty: qty, max: btn.getAttribute('data-ri-atc-max') || '99' });
        });
      }
      var total = 0;
      withQty.forEach(function (row) {
        total += row.qty;
      });
      var face = sw.querySelector('.ri-card-atc__qtyface');
      var qtyEl = sw.querySelector('[data-ri-atc-qty]');
      var removeBtn = sw.querySelector('[data-ri-choose-summary-remove]');
      var plusBtn = sw.querySelector('[data-ri-choose-summary-plus]');
      if (total > 0) {
        sw.classList.remove('is-leaving');
        sw.classList.add('is-in-cart');
        if (qtyEl && qtyEl.textContent !== total + ' in cart') qtyEl.textContent = total + ' in cart';
        if (qtyEl && qtyEl.tagName === 'BUTTON') {
          qtyEl.setAttribute('aria-label', total + ' in cart. Choose a condition');
        }
        if (face) {
          face.removeAttribute('aria-hidden');
          face.removeAttribute('inert');
        }
        if (withQty.length === 1) {
          var only = withQty[0];
          if (removeBtn) {
            removeBtn.setAttribute('data-ri-atc-remove', only.id);
            removeBtn.removeAttribute('data-ri-choose-open');
          }
          if (plusBtn) {
            plusBtn.setAttribute('data-ri-atc-plus', only.id);
            plusBtn.setAttribute('data-ri-atc-max', only.max);
            plusBtn.removeAttribute('data-ri-choose-open');
            paintPlus(plusBtn);
          }
          paintRemove(sw, only.qty);
        } else {
          if (removeBtn) {
            removeBtn.removeAttribute('data-ri-atc-remove');
            removeBtn.setAttribute('data-ri-choose-open', '');
            removeBtn.classList.remove('is-minus');
            removeBtn.setAttribute('aria-label', 'Choose a condition');
          }
          if (plusBtn) {
            plusBtn.removeAttribute('data-ri-atc-plus');
            plusBtn.setAttribute('data-ri-choose-open', '');
            plusBtn.classList.add('is-ready');
            plusBtn.disabled = false;
            plusBtn.removeAttribute('aria-hidden');
            plusBtn.removeAttribute('tabindex');
          }
        }
      } else if (sw.classList.contains('is-in-cart')) {
        leaveCart(sw);
      } else {
        sw.classList.remove('is-in-cart');
        if (qtyEl && qtyEl.textContent) qtyEl.textContent = '';
        if (face) {
          face.setAttribute('aria-hidden', 'true');
          face.setAttribute('inert', '');
        }
        if (removeBtn) removeBtn.removeAttribute('data-ri-atc-remove');
        if (plusBtn) plusBtn.removeAttribute('data-ri-atc-plus');
      }
    });
  }

  /* The Quantity line on the product page reads "(N in cart)". It only
     refreshes from a section fetch, so keep it in step with the button. */
  function syncProductCartQty() {
    document.querySelectorAll('.ri-card-atc--pdp [data-ri-atc-variant]').forEach(function (btn) {
      var qty = qtyOf(btn.getAttribute('data-ri-atc-variant'));
      var info = btn.closest('product-info') || document;
      var block = info.querySelector('.product-form__quantity');
      if (!block) return;
      var input = block.querySelector('.quantity__input');
      var rules = block.querySelector('.quantity__rules-cart');
      var count = block.querySelector('.quantity-cart');
      if (input) input.setAttribute('data-cart-quantity', String(qty));
      if (count) count.textContent = String(qty);
      if (rules) rules.classList.toggle('hidden', qty <= 0);
    });
  }

  function paint() {
    document.querySelectorAll('[data-ri-atc-variant]').forEach(paintButton);
    document.querySelectorAll('[data-ri-atc-plus]').forEach(paintPlus);
    paintChoose();
    syncProductCartQty();
  }

  function moneyHtml(cents) {
    if (window.RIMoney && window.RIMoney.formatCents) return window.RIMoney.formatCents(cents, '$');
    var n = Math.round(Number(cents) || 0);
    return '<span class="ri-money">$' + (n / 100).toFixed(2) + '</span>';
  }

  function syncHeaderCart(cart) {
    var link = document.getElementById('cart-icon-bubble');
    if (!link || !cart) return;
    var count = cart.item_count || 0;
    var label = link.querySelector('.ri-header__icon-label');
    var slot = link.querySelector('.ri-header__cart-total');
    var bubble = link.querySelector('.cart-count-bubble');
    if (bubble) bubble.remove();
    if (!count) {
      if (slot) {
        slot.hidden = true;
        slot.innerHTML = '';
      }
      if (label) label.hidden = false;
      return;
    }
    if (!slot) {
      slot = document.createElement('span');
      slot.className = 'ri-header__cart-total';
      link.appendChild(slot);
    }
    slot.hidden = false;
    slot.innerHTML = moneyHtml(cart.total_price || 0);
    if (label) label.hidden = true;
  }

  function finishChange(button) {
    if (button) button.disabled = false;
  }

  function bumpQty(variantId, delta) {
    var key = String(variantId);
    var found = false;
    var next = [];
    items.forEach(function (item) {
      var vid = item.variant_id != null ? item.variant_id : item.id;
      if (String(vid) !== key) {
        next.push(item);
        return;
      }
      found = true;
      var q = (item.quantity || 0) + delta;
      if (q > 0) next.push(Object.assign({}, item, { quantity: q }));
    });
    if (!found && delta > 0) {
      next.push({ variant_id: key, quantity: delta, key: 'pending-' + key });
    }
    items = next;
    paint();
  }

  /* Shelf plus, minus, and trash fire the same Shopify cart event as the product page. */
  function linesEvent(target, action, lines) {
    var Ctor = window.StandardEvents && window.StandardEvents.CartLinesUpdateEvent;
    if (!Ctor) return null;
    var deferred = Ctor.createPromise();
    (target || document.body).dispatchEvent(
      new Ctor({ action: action, context: 'product', lines: lines, promise: deferred.promise })
    );
    return deferred;
  }

  function settleLinesEvent(deferred, cart) {
    if (!deferred) return;
    var Ctor = window.StandardEvents && window.StandardEvents.CartLinesUpdateEvent;
    if (!Ctor || !cart || !cart.currency) {
      deferred.reject(new Error('cart'));
      return;
    }
    deferred.resolve({ cart: Ctor.createCartFromAjaxResponse(cart) });
  }

  function decreaseOne(variantId, button) {
    var line = lineOf(variantId);
    if (!line || !line.key) return;
    var lineKey = line.key;
    /* A tap right after an add, before the cart answers, finds the placeholder key (bumpQty); the cart does not know
       it, so the change failed and the row snapped back. A variant id works for a game the cart holds once. */
    if (String(lineKey).indexOf('pending-') === 0) lineKey = Number(variantId);
    var nextQty = Math.max(0, (line.quantity || 1) - 1);
    if (button) button.disabled = true;
    var start = beginChange();
    var end = onceEnd();
    bumpQty(variantId, -1);
    var lines = linesEvent(button, nextQty === 0 ? 'remove' : 'update', [{ id: lineKey, quantity: nextQty }]);
    var url = (window.routes && window.routes.cart_change_url) || '/cart/change';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: lineKey, quantity: nextQty }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        end();
        if (!cart || cart.status || cart.errors || !Array.isArray(cart.items)) {
          settleLinesEvent(lines, null);
          finishWith(start, null);
          return;
        }
        settleLinesEvent(lines, cart);
        finishWith(start, cart);
      })
      .catch(function () {
        end();
        settleLinesEvent(lines, null);
        finishWith(start, null);
      })
      .finally(function () {
        finishChange(button);
      });
  }

  function removeVariant(variantId, button) {
    var line = lineOf(variantId);
    if (!line || !line.key) return;
    var lineKey = line.key;
    /* A tap right after an add, before the cart answers, finds the placeholder key (bumpQty); the cart does not know
       it, so the change failed and the row snapped back. A variant id works for a game the cart holds once. */
    if (String(lineKey).indexOf('pending-') === 0) lineKey = Number(variantId);
    if (button) button.disabled = true;
    var start = beginChange();
    var end = onceEnd();
    bumpQty(variantId, -(line.quantity || 1));
    var lines = linesEvent(button, 'remove', [{ id: lineKey, quantity: 0 }]);
    var url = (window.routes && window.routes.cart_change_url) || '/cart/change';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: lineKey, quantity: 0 }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        end();
        if (!cart || cart.status || cart.errors || !Array.isArray(cart.items)) {
          settleLinesEvent(lines, null);
          finishWith(start, null);
          return;
        }
        settleLinesEvent(lines, cart);
        finishWith(start, cart);
      })
      .catch(function () {
        end();
        settleLinesEvent(lines, null);
        finishWith(start, null);
      })
      .finally(function () {
        finishChange(button);
      });
  }

  /* Shopify's own reason (for example only 1 left) floats under the button so the tile keeps its height. */
  function showAtcError(anchor, message) {
    var root = anchor && anchor.closest ? anchor.closest('.ri-card-atc') : null;
    if (!root) return;
    var note = root.querySelector(':scope > .ri-card-atc__error');
    if (!note) {
      note = document.createElement('p');
      note.className = 'ri-card-atc__error';
      note.setAttribute('role', 'alert');
      root.appendChild(note);
    }
    note.textContent = message || 'This could not be added. Please try again.';
    window.clearTimeout(note._riTimer);
    note._riTimer = window.setTimeout(function () {
      note.remove();
    }, 5000);
  }

  function errorText(data) {
    if (!data) return '';
    if (typeof data.description === 'string' && data.description) return data.description;
    if (typeof data.errors === 'string' && data.errors) return data.errors;
    if (typeof data.message === 'string' && data.message) return data.message;
    return '';
  }

  function addOne(variantId, button) {
    if (button) button.disabled = true;
    beginChange();
    var end = onceEnd();
    bumpQty(variantId, 1);
    var lines = linesEvent(button, 'add', [{ merchandiseId: variantId, quantity: 1 }]);
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || (data && data.status)) {
            var err = new Error('add');
            err.riMessage = errorText(data);
            throw err;
          }
        });
      })
      .then(function () {
        end();
        return loadCart(true).then(function (cart) {
          settleLinesEvent(lines, cart);
        });
      })
      .catch(function (err) {
        end();
        settleLinesEvent(lines, null);
        showAtcError(button, err && err.riMessage);
        return loadCart(true);
      })
      .finally(function () {
        finishChange(button);
      });
  }

  function schedulePaint() {
    window.clearTimeout(paintTimer);
    paintTimer = window.setTimeout(paint, 60);
  }

  function loadCart(notify) {
    /* Only a read that started with nothing on its way, and saw nothing new start, may repaint. */
    var start = epoch;
    var clean = inflight === 0;
    return fetch(cartJsUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('cart');
        return response.json();
      })
      .then(function (cart) {
        if (clean && settled(start)) applyCart(cart, notify === true);
        return cart;
      })
      .catch(function () {
        return null;
      });
  }

  function applyCart(cart, notify) {
    items = (cart && cart.items) || [];
    paint();
    syncHeaderCart(cart);
    if (!notify || typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ri-card-atc', cartData: cart });
  }

  function onCartUpdate(event) {
    if (event && event.source === 'ri-card-atc') return;
    if (event && (event.source === 'product-form' || event.source === 'ri-system-addon')) endFormChange(null);
    if (inflight > 0) return;
    if (event && event.cartData && event.cartData.items) {
      items = event.cartData.items;
      paint();
      syncHeaderCart(event.cartData);
      return;
    }
    loadCart();
  }

  function hasAtcControl(node) {
    if (!node || node.nodeType !== 1) return false;
    var sel = '[data-ri-atc-variant], [data-ri-atc-plus], [data-ri-choose-switch]';
    return node.matches(sel) || !!node.querySelector(sel);
  }

  function boot() {
    /* The page ships its cart lines, so tiles paint right away. /cart.js only
       refreshes them once the page is idle, or after a back-forward restore. */
    if (Array.isArray(window.RI_CART_SEED)) {
      items = window.RI_CART_SEED;
      paint();
      var idle = window.requestIdleCallback || function (cb) {
        return window.setTimeout(cb, 1500);
      };
      idle(function () {
        loadCart();
      }, { timeout: 4000 });
    } else {
      loadCart();
    }
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) loadCart();
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        if (!variant || variant.id == null) return;
        var max = 99;
        var tracked = variant.inventory_management != null && variant.inventory_management !== '';
        if (tracked && variant.inventory_policy !== 'continue' && typeof variant.inventory_quantity === 'number') {
          max = Math.max(0, variant.inventory_quantity);
        }
        var id = String(variant.id);
        document.querySelectorAll('.ri-card-atc--pdp').forEach(function (root) {
          root.querySelectorAll('[data-ri-atc-variant]').forEach(function (el) {
            el.setAttribute('data-ri-atc-variant', id);
            el.setAttribute('data-ri-atc-max', String(max));
          });
          root.querySelectorAll('[data-ri-atc-remove]').forEach(function (el) {
            el.setAttribute('data-ri-atc-remove', id);
          });
          root.querySelectorAll('[data-ri-atc-plus]').forEach(function (el) {
            el.setAttribute('data-ri-atc-plus', id);
            el.setAttribute('data-ri-atc-max', String(max));
          });
        });
        paint();
      });
      subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
      subscribe(PUB_SUB_EVENTS.cartError, function (event) {
        var id = event && event.productVariantId != null ? String(event.productVariantId) : '';
        if (id) {
          var btn = document.querySelector('.ri-catalog-card [data-ri-atc-variant="' + id + '"]');
          if (btn) showAtcError(btn, errorText(event));
        }
        endFormChange(null);
        if (inflight === 0) loadCart();
      });
    }
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || !form.querySelector) return;
        var btn = form.querySelector('[data-ri-atc-variant]');
        if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
        var delta = 1;
        var qtyInput = form.elements && form.elements.namedItem && form.elements.namedItem('quantity');
        if (qtyInput && qtyInput.value != null && !qtyInput.disabled) {
          var typed = parseInt(qtyInput.value, 10);
          if (typed > 0) delta = typed;
        }
        beginFormChange();
        bumpQty(btn.getAttribute('data-ri-atc-variant'), delta);
      },
      true
    );
    document.addEventListener('cart:updated', function () {
      loadCart();
    });
    document.addEventListener('click', function (event) {
      var plus = event.target.closest('[data-ri-atc-plus]');
      if (plus) {
        if (!plus.classList.contains('is-ready') || plus.disabled) return;
        event.preventDefault();
        event.stopPropagation();
        addOne(plus.getAttribute('data-ri-atc-plus'), plus);
        return;
      }
      var trash = event.target.closest('[data-ri-atc-remove]');
      if (!trash || trash.disabled) return;
      event.preventDefault();
      event.stopPropagation();
      var variantId = trash.getAttribute('data-ri-atc-remove');
      if (trash.classList.contains('is-minus')) decreaseOne(variantId, trash);
      else removeVariant(variantId, trash);
    });
    var main = document.querySelector('main');
    if (main && window.MutationObserver) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            if (hasAtcControl(added[j])) {
              schedulePaint();
              return;
            }
          }
        }
      }).observe(main, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
